import LazyImage from "components/elements/LazyImage";
import classes from "./classes.module.scss";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import Typography from "components/elements/Typography";
import { translateISO369 } from "utils/I18nText";
import { useCallback, useEffect, useState } from "react";
import { CreativeSourceCreateOperation, CreativeSourceEditOperation } from "..";

type IProps = {
	creativeSource: CreativeSourceCreateOperation | CreativeSourceEditOperation;
	onEdit: (creativeSource: CreativeSourceCreateOperation | CreativeSourceEditOperation) => void;
	onDelete: (creativeSource: CreativeSourceCreateOperation | CreativeSourceEditOperation) => void;
};

export default function CreativeSourceToCreate(props: IProps) {
	const { imageUrl } = useCreativeSourceImage(props.creativeSource);

	const onEditClick = useCallback(() => {
		props.onEdit(props.creativeSource);
	}, [props]);

	const onDeleteClick = useCallback(() => {
		props.onDelete(props.creativeSource);
	}, [props]);

	return (
		<div className={classes["root"]}>
			<div className={classes["content"]}>
				<LazyImage src={imageUrl} alt="Creative Source" className={classes["image"]} />
				<Typography type="p" size="small" weight="medium" typoFont="secondary">
					{translateISO369(props.creativeSource.request.description)}
				</Typography>
			</div>
			<div className={classes["button-container"]}>
				<PencilIcon className={classes["icon"]} onClick={onEditClick} />
				<TrashIcon className={classes["icon"]} onClick={onDeleteClick} />
			</div>
		</div>
	);
}

const useCreativeSourceImage = (creativeSource: CreativeSourceCreateOperation | CreativeSourceEditOperation) => {
	const [imageUrl, setImageUrl] = useState<string | null>(null);

	useEffect(() => {
		if (!creativeSource.image) return;
		setImageUrl(URL.createObjectURL(creativeSource.image));
	}, [creativeSource]);

	return { imageUrl };
};
